// extracted by mini-css-extract-plugin
export default {"gift":"index-module__gift--SG4V6","gift__amount":"index-module__gift__amount--za972"};